/***********************
* INDEX TAB1 CONTENT 
(CUSTOMERS AND SERVICES)
************************/

import React, { useState } from "react"
import PropTypes from "prop-types"
import { Col, Row } from "reactstrap"

// Locale
import { withTranslation } from "react-i18next"

// Customers services components
import TableStats from "./TableStats"
import ChartStats from "./ChartStats"
import CardTableBtn from "../CardTableBtn"

const CustomersServicesReporting = props => {
  // Inactive device states
  const [inActiveDevices, setInActiveDevices] = useState(0)
  // Filter view related states
  const [widgetVisible, setWidgetVisible] = useState(true)
  const [tableVisible, setTableVisible] = useState(false)

  return (
    <>
      <Row>
        <Col>
          <CardTableBtn
            widgetVisible={widgetVisible}
            tableVisible={tableVisible}
            setWidgetVisible={setWidgetVisible}
            setTableVisible={setTableVisible}
          ></CardTableBtn>
          <div className="mt-2 mb-1">
            {widgetVisible && (
              <ChartStats
                customers={props.customers}
                data={props.data}
                inActiveDevices={inActiveDevices}
                setInActiveDevices={setInActiveDevices}
                quickGuide={props.quickGuide}
              />
            )}
            {tableVisible && <TableStats minRows={0} data={props.data} />}
          </div>
        </Col>
      </Row>
    </>
  )
}

CustomersServicesReporting.propTypes = {
  data: PropTypes.any,
  customers: PropTypes.any,
  quickGuide: PropTypes.any,
}
export default withTranslation()(CustomersServicesReporting)
